import React, { Component } from 'react';
import { Spinner } from "@blueprintjs/core";

export default class Loading extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false
        }
    }

    render() {
        if (this.props.show) return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Spinner />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Loading.jsx